// extracted by mini-css-extract-plugin
module.exports = {"isActive":"machineItem_isActive__2i6eP","isBordered":"machineItem_isBordered__1cUvM"};